module.exports = __webpack_public_path__ + "img/bt.8cd5d7ee.svg";